import React from 'react';
import classNames from 'classnames';
import I18n from 'i18n-js';

import { RCCloseButton } from '@reverbdotcom/cadence/components';
import { useId } from '@reach/auto-id';

interface IProps {
  value?: string;
  onChange: (evt: { target: { value: string } }) => void;
  onSubmit?: React.FormEventHandler<null>;
  onClear?: () => void;
  placeholder?: string;
  large?: boolean;
  action?: string;
  name?: string;
  label?: string;
  hiddenLabel?: boolean;
  id?: string;
  rounded?: boolean;
}

export default function SearchInputGroup({
  value = '',
  onChange,
  onSubmit,
  onClear,
  placeholder,
  large,
  action,
  name,
  label = undefined,
  hiddenLabel = false,
  id,
  rounded,
}:IProps) {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const inputId = useId(id);

  function clearInput() {
    inputRef?.current?.focus();
    onChange({ target: { value: '' } });
    onClear?.();
  }

  const classes = classNames(
    'search-input-group',
    { 'search-input-group--large': large },
    { 'search-input-group--rounded': rounded },
  );

  return (
    <div className={classes}>
      <form
        onSubmit={onSubmit}
        action={action}
      >
        <label htmlFor={inputId} className={hiddenLabel ? 'visually-hidden' : 'mb-1'}>
          {label || I18n.t('commons.forms.searchLabel')}
        </label>
        <div className="search-input-group__inner">
          <div
            className="search-input-group__field"
          >
            <input
              className="search-input-group__input"
              type="text"
              value={value}
              onChange={onChange}
              placeholder={placeholder}
              ref={inputRef}
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck={false}
              id={inputId}
              name={name}
            />
            {value && (
              <span className="search-input-group__clear">
                <RCCloseButton
                  aria-label={I18n.t('commons.forms.clearLabel')}
                  onClick={clearInput}
                />
              </span>
            )}
          </div>
          <button
            className="search-input-group__button"
            type="submit"
            aria-label={I18n.t('commons.forms.submitLabel')}
          />
        </div>
      </form>
    </div>
  );
}
